var Link_Version = "1.0.20230223.1"; // do not modify
var Link_Version_Test = "1.0.20230223.101";
var version = Link_Version;
var versionTest = Link_Version_Test;
var js_script = {"targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["我的數字變數",0]},"string_variable":{"f2a/iC7MJIkclqFTvQsb":["我的字串變數",0]},"boolean_variable":{},"lists":{},"string_lists":{},"broadcasts":{".C7@/LFr8sl_L7P_%uE=":"訊息1"},"blocks":{"vTJuU+VMuti*vv:#O.VP":{"opcode":"event_whenstarted","next":"{yldb1)QZcnPWH;SwwT^","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":298,"y":288},"{yldb1)QZcnPWH;SwwT^":{"opcode":"sound_playnote","next":null,"parent":"vTJuU+VMuti*vv:#O.VP","inputs":{"NOTE":[3,"7AB}Q-=*Cq%Zr0|,b{?|","+]YMXx$|!XdMA_|N(w3="],"BEATS":[1,[4,"0.25"]]},"fields":{"BUZZERNAME":["蜂鳴器A1",null]},"shadow":false,"topLevel":false},"+]YMXx$|!XdMA_|N(w3=":{"opcode":"note","next":null,"parent":null,"inputs":{},"fields":{"NOTE":["60",null]},"shadow":true,"topLevel":true,"x":626,"y":347},"7AB}Q-=*Cq%Zr0|,b{?|":{"opcode":"sound_tempo","next":null,"parent":"{yldb1)QZcnPWH;SwwT^","inputs":{},"fields":{},"shadow":false,"topLevel":false}},"comments":{},"sounds":[],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"brainType":"EDU","editMode":"BLOCK_MODE","pythonCode":"from vm.brain import *\nfrom vm.constant import *\nfrom vm.utils import *\nfrom vm.button import *\nfrom vm.touch_led import *\nfrom vm.edu import *\nfrom vm.color_sensor import *\nfrom vm.gyro import *\nfrom vm.motor import *\nfrom vm.drivetrain import *\nfrom vm.screen import *\nfrom vm.sound import *\nfrom vm.extensions import *\nfrom vm.vision import *\nfrom vm.aispeech import *\n\nConstant.STAGE = True\n\nmy_variable_1 = 0 # 我的數字變數\nmy_variable_2 = '0' # 我的字串變數\n\nBrain.init()\ndef event_whenstarted_1():\n    global my_variable_1, my_variable_2\n    pass\n\n\n\nBrain.register_started(event_whenstarted_1)\n\nBrain.start()\n","vr":"","currentAudioSize":0,"extensions":[],"devices":[{"connectPortArray":["A1"],"id":"buzzer-6923","name":"蜂鳴器A1","type":"buzzer","isNameEdited":false,"other":{}}],"controllers":[],"ver":{"projectName":"我的專案"},"meta":{"semver":"3.0.0","vm":"0.0.110-20220831","agent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) PINBOLab/2.0.170-20220905-WW Chrome/89.0.4389.128 Electron/12.2.3 Safari/537.36"}};
function replaceToken(str){
    str.replace('i@','i/@');
    str.replace('op@','op/@');
    str.replace('f@','f/@');
    str.replace('v@','v/@');
    str.replace('l@','l/@');
    return str;
}

function recursiveOperator(blocks, arg){
    var type = arg[0];
    if(arg[1] == null){
        return ['i@'+0];
    } else if(type == 1){
        return ['i@'+replaceToken(arg[1][1])];
    } else if(type == 3 && (arg[1][0]==12 || arg[1][0]==13)){
        if (arg[1][0]==12){
            return ['v@'+replaceToken(arg[1][1])];
        } else if(arg[1][0]==13){
            return ['l@'+replaceToken(arg[1][1])];
        }
    } else {
        var block = blocks[arg[1]];
        var opcode = block.opcode;
        var fieldarr = [];
        var ret = [];
        for(var i in block.fields){
            fieldarr = fieldarr.concat(['f@'+block.fields[i][0]]);
        }
        if (block.hasOwnProperty('refine') && block.refine === 1) {
            for (var i in block.inputs) {
                ret = ret.concat(block.inputs[i]);
            }
        } else {
            for (var i in block.inputs) {
                ret = ret.concat(recursiveOperator(blocks, block.inputs[i]));
            }
        }
        ret = ret.concat(fieldarr).concat(['op@'+opcode]);
        delete(blocks[arg[1]]);
        return ret;
    }
}

function refineOperator(blocks) {
    for(var obj in blocks) {
        var block = blocks[obj];
        var inputs = block.inputs;
        for(var i in inputs){
            if(!i.startsWith("SUBSTACK") && !i.startsWith("BROADCAST_INPUT")){
                inputs[i] = recursiveOperator(blocks,inputs[i]);
            }
        }
        block.refine = 1;
    }
    return blocks;
}

function deleteRedundent(blocks) {
    for(var obj in blocks) {
        var block = blocks[obj];
        delete block['shadow'];
        delete block['topLevel'];
        delete block['refine'];
    }
    return blocks;
}

function refineJS(jsonScript, brainType) {
    var targets = jsonScript.targets;
    var variables = targets[0].variables;
    var lists = targets[0].lists;
    var blocks;
    if (targets[1] !== undefined && targets[1].blocks != undefined) {
        blocks = targets[1].blocks;
    } else {
        blocks = targets[0].blocks;
    }
    console.log("-------------------------START-------------------------");

    blocks = swapEvent(blocks);
    blocks = add_checkKey(blocks);
    blocks = editCheckId(blocks);
    blocks = editBroadcastBlocks(blocks);
    blocks = editProcedures(blocks);
    //Edit list and variable name in blocks
    var variableList = [];
    for(var obj in variables) {
        variableList.push(obj);
    }

    var listvariableList = [];
    for(var obj in lists) {
         listvariableList.push(obj);
    }

    targets[0].variables = JSON.parse(editVariables(variables, variableList));
    targets[0].lists = JSON.parse(editLists(lists, variableList));

    blocks = refineOperator(blocks);
    blocks = editAllBlockId(blocks, variableList, listvariableList);
    blocks = deleteRedundent(blocks);
    if (targets[1] !== undefined && targets[1].blocks != undefined) {
        targets[1].blocks = blocks;
    } else {
        targets[0].blocks = blocks;
    }

    jsonScript.targets = targets;
    console.log("-------------------------END-------------------------");

    if (brainType == 1) {
        //For Entry/Pro
        return JSON.stringify(jsonScript);
    } else if (brainType == 2) {
        //For EDU
        return getMCUstring(jsonScript, targets, blocks);
    }
}

function download(filename, text) {
    var pom = document.createElement('a');
    pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    pom.setAttribute('download', filename);

    if (document.createEvent) {
        var event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        pom.dispatchEvent(event);
    }
    else {
        pom.click();
    }
}

function getMCUstring(jsonScript, targets, blocks) {
    //For MCU
    var mcuFileStr = "";
    var mcuAddrOffset = 512;
    var mcuCounter = 0;

    if(jsonScript.controllers) {
        var conArr = [];
        for(var con in jsonScript.controllers){
            var conObj = {};

            var useMainController = false;
            for(var obj in jsonScript.controllers[con]){
                if(obj == 'type' || obj == 'id') continue;
                var btnObj = jsonScript.controllers[con][obj];
                var btnArr = [];
                if(Object.values(btnObj).reduce(function(a,b){return a||b}, null)){
                    if(btnObj.deviceName){
                        if (jsonScript.devices) {
                            for(var device in jsonScript.devices){
                                if(jsonScript.devices[device].name === btnObj.deviceName){
                                    if(jsonScript.devices[device].type === "threeWireMotor") {
                                        var a = jsonScript.devices[device].other.rotation === "forward"? 1:-1;
                                        var b = btnObj.rotation === "forward"? 1:-1;
                                        btnArr.push(a*b > 0? 1: 0); //0 => reverse, 1 => forward
                                        btnArr.push(jsonScript.devices[device].connectPortArray[0]);
                                        useMainController = true;
                                    } else if(jsonScript.devices[device].type === "drivetrain") {
                                        if(btnObj.mode === "leftDrive"){
                                            btnArr.push(2);
                                        }
                                        else if(btnObj.mode === "rightDrive"){
                                            btnArr.push(3);
                                        }
                                        else if(btnObj.mode === "tankDrive"){
                                            btnArr.push(4);
                                        }
                                        else if(btnObj.mode === "directDrive"){
                                            btnArr.push(5);
                                        }
                                        if(jsonScript.devices[device].other.path === "back") {
                                            btnArr.push(jsonScript.devices[device].connectPortArray[1]);
                                            btnArr.push(jsonScript.devices[device].connectPortArray[0]);
                                        } else {
                                            btnArr = btnArr.concat(jsonScript.devices[device].connectPortArray);
                                        }
                                        useMainController = true; 
                                    }
                                    conObj[obj] = btnArr;
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            //TT:1371430, only use minor controller
            //[{"drivetrain":[2,"A1","A2"]}] -> [{}, {"drivetrain":[2,"A1","A2"]}] 
            if(useMainController == false && con == 0){
                conArr.push({});
            }

            if(!(Object.entries(conObj).length === 0)){
                conArr.push(conObj);
            }
        }
        var controllerStr = JSON.stringify(conArr);
        var controllerLength = controllerStr.length;
        if (controllerLength<mcuAddrOffset) {
            var fwCount = fullwidthCount(controllerStr);
            var totalCount = 511- (fwCount*2);
            while(controllerStr.length<totalCount) {
                controllerStr = controllerStr + " ";
            }
            var hexStr = controllerStr.hexEncode() + '00';
            mcuFileStr = mcuFileStr + hex2a(hexStr);
            mcuCounter += 1;
        } else {
            //For lists length > 512
        }
    }

    if (jsonScript.devices) {
        for(var obj in jsonScript.devices){
            if(jsonScript.devices[obj].type === 'threeWireMotor'){
                jsonScript.devices[obj]['rotation'] = jsonScript.devices[obj].other['rotation'];
            } else if(jsonScript.devices[obj].type === 'drivetrain'){
                jsonScript.devices[obj]['path'] = jsonScript.devices[obj].other['path'];
                jsonScript.devices[obj]['fixMethod'] = jsonScript.devices[obj].other['fixMethod'];
                jsonScript.devices[obj]['leftPercentage'] = jsonScript.devices[obj].other['leftPercentage'];
                jsonScript.devices[obj]['rightPercentage'] = jsonScript.devices[obj].other['rightPercentage'];
            }
            delete jsonScript.devices[obj].other;
        }
        var devicesStr = JSON.stringify(jsonScript.devices);
        var devicesLength = devicesStr.length;
        if (devicesLength<1024) {
            var fwCount = fullwidthCount(devicesStr);
            var totalCount = 1023- (fwCount*2);
            while(devicesStr.length<totalCount) {
                devicesStr = devicesStr + " ";
            }
            var hexStr = devicesStr.hexEncode() + '00';
            mcuFileStr = mcuFileStr + hex2a(hexStr);
            mcuCounter += 2;
        } else {
            //For lists length > 512
        }
    }

    // //Check Variables
    // var variablesLength = JSON.stringify(targets[0].variables).length;
    // if (variablesLength<mcuAddrOffset) {
    //     var variableStr = JSON.stringify(targets[0].variables);
    //     var fwCount = fullwidthCount(variableStr);
    //     var totalCount = 511- (fwCount*2);
    //     while(variableStr.length<totalCount) {
    //         variableStr = variableStr + " ";
    //     }
    //     var hexStr = variableStr.hexEncode() + '00';
    //     mcuFileStr = mcuFileStr + hex2a(hexStr);
    // } else {
    //     //For variables length > 512
    // }

    //Check Lists
    var listsLength = JSON.stringify(targets[0].lists).length;
    if (listsLength<mcuAddrOffset) {
        var listStr = JSON.stringify(targets[0].lists);
        var fwCount = fullwidthCount(listStr);
        var totalCount = 511- (fwCount*2);
        while(listStr.length<totalCount) {
            listStr = listStr + " ";
        }
        var hexStr = listStr.hexEncode() + '00';
        mcuFileStr = mcuFileStr + hex2a(hexStr);
        mcuCounter += 1;
    } else {
        //For lists length > 512
    }

    //Check event
    var event = {};
    event['event_whenbumperbutton'] = [];
    event['event_whenrfiddetectsdata'] = [];
    for(var obj in blocks) {
        var block = blocks[obj];
        switch(block.opcode){
            case 'event_whencontrollerbutton':
            case 'event_whencontrolleraxischanged':
            case 'event_whenbrainbutton':
                break;

            case 'event_whenbumperbutton':
                var event_whenbumperbutton = event['event_whenbumperbutton'];
                var bumperName = block.fields['BUMPERNAME'][0];
                var option = block.fields['PRESSED'][0] == 'pressed'? 1:0;
                var hasSameEvent = false;
                for(var i in event_whenbumperbutton){
                    if(event_whenbumperbutton[i]['port_name'] == bumperName && event_whenbumperbutton[i]['option'] == option){
                        event_whenbumperbutton[i]['next'].push(obj);
                        hasSameEvent = true;
                        break;
                    }
                }
                if(!hasSameEvent) {
                    var eventObj = {};
                    eventObj['port_name'] = bumperName;
                    eventObj['option'] = option;
                    eventObj['next'] = [obj];
                    event_whenbumperbutton.push(eventObj);
                }
                break;
            case 'event_whenrfiddetectsdata':
                var rfid_obj = [obj, blocks[obj].fields["CARD"][0]];
                event['event_whenrfiddetectsdata'].push(rfid_obj);
                break;
        }
    }

    //Check bumperEvent
    var eventWhenbumperbuttonLength = JSON.stringify(event['event_whenbumperbutton']).length;
    if (eventWhenbumperbuttonLength<mcuAddrOffset) {
        var eventWhenbumperbuttonStr = JSON.stringify(event['event_whenbumperbutton']);
        var fwCount = fullwidthCount(eventWhenbumperbuttonStr);
        var totalCount = 511- (fwCount*2);
        while(eventWhenbumperbuttonStr.length<totalCount) {
            eventWhenbumperbuttonStr = eventWhenbumperbuttonStr + " ";
        }
        var hexStr = eventWhenbumperbuttonStr.hexEncode() + '00';
        mcuFileStr = mcuFileStr + hex2a(hexStr);
        mcuCounter += 1;
    } else {
        //For lists length > 512
    }

    //Check RFIDEvent
    var rfid_metadata = {};
    var blocks_str = JSON.stringify(blocks);
    var use_rfid = blocks_str.includes('sensing_rfiddetecteddata') || blocks_str.includes('sensing_rfiddetectsdata') 
    || blocks_str.includes('event_whenrfiddetectsdata');
    rfid_metadata['use'] = use_rfid;
    rfid_metadata['event'] = event['event_whenrfiddetectsdata'];
    var rfid_metadata_length = JSON.stringify(rfid_metadata).length;
    if (rfid_metadata_length<mcuAddrOffset) {
        var rfid_metadata_str = JSON.stringify(rfid_metadata);
        var fwCount = fullwidthCount(rfid_metadata_str);
        var totalCount = 511- (fwCount*2);
        while(rfid_metadata_str.length<totalCount) {
            rfid_metadata_str = rfid_metadata_str + " ";
        }
        var hexStr = rfid_metadata_str.hexEncode() + '00';
        mcuFileStr = mcuFileStr + hex2a(hexStr);
        mcuCounter += 1;
    } else {
        //For lists length > 512
    }

    //Check Block
    blocks = check_length_and_offset(blocks);
    for(var obj in blocks) {
        var block = blocks[obj];
        var blockStr = JSON.stringify(block);
        var fwCount = fullwidthCount(blockStr);
        var blockLength = JSON.stringify(block).length + 2*fwCount;
        if (blockLength<mcuAddrOffset) {
            var totalCount = 511- (fwCount*2);
            while(blockStr.length<totalCount) {
                blockStr = blockStr + " ";
            }
            var hexStr = blockStr.hexEncode() + '00';    
            mcuFileStr = mcuFileStr + hex2a(hexStr);
            mcuCounter += 1;
        } else if(blockLength < mcuAddrOffset*2) {
            //For BlockList > 512
            var totalCount = 1023- (fwCount*2);
            while(blockStr.length<totalCount) {
                blockStr = blockStr + " ";
            }
            var hexStr = blockStr.hexEncode() + '00';    
            mcuFileStr = mcuFileStr + hex2a(hexStr);
            mcuCounter += 2;
        }
    }

    //Check deviceInfo (Tail place)
    if (jsonScript.ver) {
        var verStr = JSON.stringify(jsonScript.ver);
        var verLength = verStr.length;
        if (verLength<mcuAddrOffset) {
            var fwCount = fullwidthCount(verStr);
            var totalCount = 511- (fwCount*2);
            while(verStr.length<totalCount) {
                verStr = verStr + " ";
            }
            var hexStr = verStr.hexEncode() + '00';
            mcuFileStr = mcuFileStr + hex2a(hexStr);
        } else {
            //For lists length > 512
        }
    }

    //Check deviceInfo (First place)
    if (jsonScript.ver) {
        var verStr = JSON.stringify(Object.assign({}, jsonScript.ver, {'tailPosition': mcuCounter + 1}));
        var verLength = verStr.length;
        if (verLength<mcuAddrOffset) {
            var fwCount = fullwidthCount(verStr);
            var totalCount = 511- (fwCount*2);
            while(verStr.length<totalCount) {
                verStr = verStr + " ";
            }
            var hexStr = verStr.hexEncode() + '00';
            mcuFileStr = hex2a(hexStr) + mcuFileStr;
        } else {
            //For lists length > 512
        }
    }

    return mcuFileStr;
}

if (!Object.entries) {
    Object.entries = function( obj ){
      var ownProps = Object.keys( obj ),
         i = ownProps.length,
         resArray = new Array(i); // preallocate the Array

      while (i--)
         resArray[i] = [ownProps[i], obj[ownProps[i]]];
      return resArray;
    };
}

function check_length_and_offset(blocks){
    var check_again = false;
    var mcuAddrOffset = 512;
    var blocks_entries = Object.entries(blocks);
    for(var i in blocks_entries){
        var block = blocks_entries[i][1];
        var block_key = blocks_entries[i][0];
        // var block = blocks[obj];
        var block_str = JSON.stringify(block);
        var fwCount = fullwidthCount(block_str);
        if(block_str.length + fwCount*2< mcuAddrOffset){
             
        } else if((!block.hasOwnProperty('offset')) && (block_str.length + fwCount*2 < mcuAddrOffset*2)){
            block['offset'] = true;
            check_again = offset_id(blocks_entries, block_key);
        }
    }
    var new_blocks = {};
    for(var i in blocks_entries){
        new_blocks[blocks_entries[i][0]] = blocks_entries[i][1];
    }
    blocks = new_blocks;
    if(check_again){
        blocks = check_length_and_offset(blocks);
    }
    for(var obj in blocks){
        delete blocks[obj]['offset'];
    }
    return blocks;
}

function offset_id(blocks_entries, offset_point){
    var check_again = false;
    var mcuAddrOffset = 512;
    for(var i in blocks_entries){
        var block = blocks_entries[i][1];
        var block_key = blocks_entries[i][0];
        if(Number(block_key) > Number(offset_point)){
            blocks_entries[i][0] = String(Number(block_key) + 1);
        }
        if(block.checkId != null && Number(block.checkId) > Number(offset_point)){
            block.checkId = String(Number(block.checkId) + 1);
            if((!block.hasOwnProperty('offset')) && (block.checkId == '10')){
                var block_str = JSON.stringify(block);
                var fwCount = fullwidthCount(block_str);
                if(block_str.length + fwCount*2>= mcuAddrOffset){
                    check_again = true;
                }
            }
        }
        if(block.parent != null && Number(block.parent) > Number(offset_point)){
            block.parent = String(Number(block.parent) + 1);
            if((!block.hasOwnProperty('offset')) && (block.parent == '10')){
                var block_str = JSON.stringify(block);
                var fwCount = fullwidthCount(block_str);
                if(block_str.length + fwCount*2>= mcuAddrOffset){
                    check_again = true;
                }
            }
        }
        if(block.next != null && Number(block.next) > Number(offset_point)){
            block.next = String(Number(block.next) + 1);
            if((!block.hasOwnProperty('offset')) && (block.next == '10')){
                var block_str = JSON.stringify(block);
                var fwCount = fullwidthCount(block_str);
                if(block_str.length + fwCount*2>= mcuAddrOffset){
                    check_again = true;
                }
            }
        }
        if(block.inputs.hasOwnProperty('SUBSTACK') && Number(block.inputs['SUBSTACK'][2]) > Number(offset_point)){
            block.inputs['SUBSTACK'][2] = String(Number(block.inputs['SUBSTACK'][2]) + 1);
            if((!block.hasOwnProperty('offset')) && (block.inputs['SUBSTACK'][2] == '10')){
                var block_str = JSON.stringify(block);
                var fwCount = fullwidthCount(block_str);
                if(block_str.length + fwCount*2>= mcuAddrOffset){
                    check_again = true;
                }
            }
        }
        if(block.inputs.hasOwnProperty('SUBSTACK2') && Number(block.inputs['SUBSTACK2'][2]) > Number(offset_point)){
            block.inputs['SUBSTACK2'][2] = String(Number(block.inputs['SUBSTACK2'][2]) + 1);
            if((!block.hasOwnProperty('offset')) && (block.inputs['SUBSTACK2'][2] == '10')){
                var block_str = JSON.stringify(block);
                var fwCount = fullwidthCount(block_str);
                if(block_str.length + fwCount*2>= mcuAddrOffset){
                    check_again = true;
                }
            }
        }
    }
    return check_again;
}

function fullwidthCount(word) {
    var m = word.match(/[^\x00-\xff]/g);
    return m? m.length: 0;
}

function hex2a(hex) {
    var j;
    var hexes = hex.match(/.{1,4}/g) || [];
    var back = "";
    for(j = 0; j<hexes.length; j++) {
        back += String.fromCharCode(parseInt(hexes[j], 16));
    }

    return back;
}

String.prototype.hexEncode = function(){
    var hex, i;

    var result = "";
    for (i=0; i<this.length; i++) {
        hex = this.charCodeAt(i).toString(16);
        result += ("000"+hex).slice(-4);
    }
    return result
}

function swapEvent(blocks) {
    var newBlocks = {};
    //Find Event
    for(var obj in blocks) {
        var block = blocks[obj];
        var opcode = block.opcode;
        if (opcode === "event_whencontrollerbutton" || opcode === "event_whencontrolleraxischanged" ||
            opcode === "event_whenbrainbutton" || opcode === "event_whentimergreaterthan" ||
            opcode === "event_whenbroadcastreceived" || opcode === "event_whenrfiddetectsdata" ||
            opcode === "event_whenstarted" || opcode === "event_whenbumperbutton") {
            //console.log("opcode : " + opcode);
            newBlocks[obj] = block;
        }
        delete blocks.obj;
    }

    //Find Start Block
    for(var obj in blocks) {
        var block = blocks[obj];
        var opcode = block.opcode;
        if (opcode === "event_whenflagclicked") {
            //console.log("opcode : " + opcode);
            newBlocks[obj] = block;
        }
        delete blocks.obj;
    }

    //Find all if/else blocks
    for(var obj in blocks) {
        var block = blocks[obj];
        var opcode = block.opcode;
        if (opcode === "control_if" || opcode === "control_if_else") {
            newBlocks[obj] = block;
        }
        delete blocks.obj;
    }
    //Import other blocks
    for(var obj in blocks) {
        var block = blocks[obj];
        newBlocks[obj] = block;
        delete blocks.obj;
    }
    //Print new blocks 
    return newBlocks;
}

function add_checkKey(blocks) {
    for(var obj in blocks) {
        var block = blocks[obj];
        block.checkId = block.next;
    }
    return blocks;
}

function editCheckId(blocks) {
    for(var obj in blocks) {
        var block = blocks[obj];
        if (block.verify != true) {
            var outestParentId = traceControlParent(blocks, obj);
            if(blocks[outestParentId].verify != true){
                traceNext(blocks, blocks[outestParentId], outestParentId);
            }
        }
    }

    for(var obj in blocks) {
        var block = blocks[obj];
        delete block.verify
    }

    return blocks;
}

function traceControlParent(blocks, rootId) {
    var parentBlock = rootId;
    var id = rootId;
    while (!blocks[id].opcode.startsWith("event_when")){
        var block = blocks[id];
        switch(block.opcode) {
                case "control_repeat_until":
                case "control_while":
                case "control_forever":
                case "control_repeat":
                case "control_if":
                case "control_if_else":
                    if(block.verify != true){
                        parentBlock = id;
                    }
                    break;
        }
        if(!block.parent || block.parent == null) break;
        id = block.parent;
    }
    return parentBlock;
}

function traceNext(blocks, block, rootId) {
    if (block.inputs) {
        switch(block.opcode) {
            case "control_repeat_until":
            case "control_while":
            case "control_forever":
            case "control_repeat":
                block.verify = true
                if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                    traceWhileObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], rootId, block.next);
                } else {
                    //console.log(opcode + " no SUBSTACK !!!");
                }
                break;
            case "control_if":
                block.verify = true;
                if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                    traceSubObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], null, block.next);
                } else {
                    //console.log(opcode + " no SUBSTACK !!!");
                }
                break;
            case "control_if_else":
                block.verify = true;
                if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                    traceSubObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], null, block.next);
                } else {
                    //console.log(opcode + " no SUBSTACK !!!");
                }
                if(block.inputs.SUBSTACK2 && block.inputs.SUBSTACK2[1]) {
                    traceSubObj(blocks, blocks[block.inputs.SUBSTACK2[1]], block.inputs.SUBSTACK2[1], null, block.next);
                } else {
                    //console.log(opcode + " no SUBSTACK2 !!!");
                }
                break;        
        }
    } else {
        //console.log(opcode + " no inputs !!!");
    }
}

function traceWhileObj(blocks, block, blockId, rootId, rootNext) {
    // console.log("@@@@@@@@@@@  traceWhileObj   rootId : " + rootId + " rootNext : " + rootNext);
    var lastId = blockId;

    while(block) {
        block.verify = true;
        if (block.opcode === "control_if") {
            if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                traceSubObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], rootId, block.next? block.next: rootId);
            }
        }
        if (block.opcode === "control_if_else") {
            if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                traceSubObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], rootId, block.next? block.next: rootId);
            }
            if (block.inputs.SUBSTACK2 && block.inputs.SUBSTACK2[1]) {
                traceSubObj(blocks, blocks[block.inputs.SUBSTACK2[1]], block.inputs.SUBSTACK2[1], rootId, block.next? block.next: rootId);
            }
        }
        if (block.opcode === "control_repeat_until" || block.opcode === "control_while" || block.opcode === "control_forever" || block.opcode === "control_repeat") {
            if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                traceWhileObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], lastId, block.next? block.next: rootId);
            }
        }
        if (block.opcode === "control_break" || block.opcode === "control_stop") {
            if(rootId) {
                block.checkId = rootId;
            }
        }
        lastId = block.next? block.next:lastId;
        block = blocks[block.next];
    }
    blocks[lastId].checkId = rootId;
    return blocks;
}

function traceSubObj(blocks, block, blockId, rootId, rootNext) {
    // console.log("@@@@@@@@@@@  traceSubObj   rootId : " + rootId + " rootNext : " + rootNext + " blockId :" + blockId + "  blockNext : " + block.next);
    var lastId = blockId;
    block.verify = true;

    //Middle Block
    while(block) {
        block.verify = true;
        if (block.opcode === "control_if") {
            if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                traceSubObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], rootId, block.next? block.next: rootNext);
            }
        }
        if (block.opcode === "control_if_else") {
            if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                traceSubObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], rootId, block.next? block.next: rootNext);
            }
            if (block.inputs.SUBSTACK2 && block.inputs.SUBSTACK2[1]) {
                traceSubObj(blocks, blocks[block.inputs.SUBSTACK2[1]], block.inputs.SUBSTACK2[1], rootId, block.next? block.next: rootNext);
            }
        }
        if (block.opcode === "control_repeat_until" || block.opcode === "control_while" || block.opcode === "control_forever" || block.opcode === "control_repeat") {
            if (block.inputs.SUBSTACK && block.inputs.SUBSTACK[1]) {
                traceWhileObj(blocks, blocks[block.inputs.SUBSTACK[1]], block.inputs.SUBSTACK[1], lastId, block.next? block.next: rootNext);
            }
        }
        if (block.opcode === "control_break" || block.opcode === "control_stop") {
            if(rootId) {
                block.checkId = rootId;
            }
        }
        lastId = block.next? block.next:lastId;
        block = blocks[block.next];
    }
    //console.log("@@@@@@@@@@@  get last block id : " + lastId  + "   rootId : " + rootId + " rootNext : " + rootNext);
    //Last block
   if (rootNext) {
        blocks[lastId].checkId = rootNext;
    } else {
        blocks[lastId].checkId = rootId;
    }
    return blocks;
}

function editProcedures(blocks){
    // refine definition block & prototype block
    for(var def_obj in blocks){
        var def_block = blocks[def_obj];
        if(def_block.opcode == 'procedures_definition'){
            var proto_id = def_block.inputs.custom_block[1];
            var proto_block = blocks[proto_id];
            for(var input in proto_block.inputs){
                delete(blocks[proto_block.inputs[input][1]]);
            }
            def_block.inputs = proto_block.mutation;
            delete(blocks[proto_id]);
        }
    }

    // mapping call block to definition block
    for(var call_obj in blocks){
        var call_block = blocks[call_obj];
        if(call_block.opcode == 'procedures_call'){
            for(var def_obj in blocks){
                var def_block = blocks[def_obj];
                if(def_block.opcode == 'procedures_definition' && 
                def_block.inputs.argumentids == call_block.mutation.argumentids &&
                def_block.inputs.proccode == call_block.mutation.proccode){
                    call_block.mutation = def_obj;
                    var new_inputs = {};
                    for(var input in call_block.inputs){
                        var arg_index = JSON.parse(def_block.inputs.argumentids).indexOf(input);
                        var arg_name = JSON.parse(def_block.inputs.argumentnames)[arg_index];
                        new_inputs[arg_name] = call_block.inputs[input];
                    }
                    call_block.inputs = new_inputs;
                }
            }
        }
    }

    // delete redundent in definition block
    for(var def_obj in blocks){
        var def_block = blocks[def_obj];
        if(def_block.opcode == 'procedures_definition'){
            def_block.inputs = {};
        }
    }
    return blocks;
}

function editBroadcastBlocks(blocks){
    for(var obj in blocks) {
        var block = blocks[obj];
        var checkId = block.checkId;
        if (block.inputs) {
            switch(block.opcode) {
                case "event_broadcastandwait":
                case "event_broadcast":
                    if (block.fields.BROADCAST_OPTION) {
                        var broadcast_list = traceBroadcastObj(blocks, block.fields.BROADCAST_OPTION);
                        block.fields.BROADCAST_OPTION = broadcast_list;
                    }
                break;
            }
        }
    }
    return blocks;
}

function editVariables(variables, variableList) {
    var variableStr = JSON.stringify(variables);
    var newVariableStr = variableStr;

    for (var i=0; i<variableList.length; i++) {
        variableStr = variableStr.replace(variableList[i],"variable_"+i);
        if (variableStr != newVariableStr) {
            newVariableStr = variableStr;
            i = i-1;
        }
    }
    return newVariableStr;
}

function editLists(lists, listvariableList) {
    var listStr = JSON.stringify(lists);
    var newListStr = listStr;

    for (var i=0; i<listvariableList.length; i++) {
        listStr = listStr.replace(listvariableList[i],"list_"+i);
        if (listStr != newListStr) {
            newListStr = listStr;
            i = i-1;
        }
    }
    return newListStr;
}

function traceBroadcastObj(blocks, message){
    var ret = [];
    for(var obj in blocks) {
        var block = blocks[obj];
        var opcode = block.opcode;
        if (opcode == "event_whenbroadcastreceived") {
            if (block.fields.BROADCAST_OPTION){
                if(block.fields.BROADCAST_OPTION[0] == message[0] && block.fields.BROADCAST_OPTION[1] == message[1]) {
                    ret.push(obj);
                }
            }
        }
    }
    return ret;
}

function editAllBlockId(blocks, variableList, listvariableList) {
    var index = 0;
    var blocksStr = JSON.stringify(blocks);
    var idList = []
    for(var obj in blocks) {
        idList.push(obj);
    }

    var newblockStr = blocksStr;
    //Edit block Id
    for (var i=0; i<idList.length; i++) {
        blocksStr = blocksStr.replace(idList[i],i);
        if (blocksStr != newblockStr) {
            newblockStr = blocksStr;
            i = i-1;
        }
    }

    //Edit variable
    for (var i=0; i<variableList.length; i++) {
        blocksStr = blocksStr.replace(variableList[i],"variable_"+i);
        if (blocksStr != newblockStr) {
            newblockStr = blocksStr;
            i = i-1;
        }
    }
    //Edit list
    for (var i=0; i<listvariableList.length; i++) {
        blocksStr = blocksStr.replace(listvariableList[i],"list_"+i);
        if (blocksStr != newblockStr) {
            newblockStr = blocksStr;
            i = i-1;
        }
    }
    return JSON.parse(blocksStr);
}

function getLinkVersion(){
	return version;
}

function getLinkVersionTest() {
    return versionTest;
}

module.exports = {
    refineJS: refineJS,
    getLinkVersion: getLinkVersion,
    getLinkVersionTest: getLinkVersionTest
};


